import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useFetchPortfolios } from 'modules/common/GraphQL/portfolios/hooks';
import { PanelTitle, SimpleDataList } from 'ui';

export const HomeRecentPortfolios = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [portfolios, setPortfolios] = useState([]);

  const { data, loading } = useFetchPortfolios(0, 5, [
    { column: 'modifiedDate', direction: 'DESC' },
  ]);

  useEffect(() => {
    if (!loading && data && data.portfolios) {
      setPortfolios(
        data.portfolios.map(({ id, name, noOfItems }) => ({
          id,
          primaryText: name,
          secondaryText: `${noOfItems.entities} ${t('entities')}`,
        })),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading]);

  const handleItemClick = ({ id }) => {
    navigate(`/portfolios/${id}`);
  };

  return (
    <>
      <PanelTitle>{t('My recent portfolios')}</PanelTitle>
      <SimpleDataList
        data={portfolios}
        loading={loading}
        onItemClick={handleItemClick}
        emptyText={t('There are no portfolios yet.')}
      />
    </>
  );
};
